import { createFileRoute } from '@tanstack/react-router';
import { CseDeferredOrdersPage } from '@/features/billetterie-orders/components/CseDeferredOrdersPage';

export const Route = createFileRoute('/$commiteeSlug/beneficiaries/billetterie-orders/')({
  component: CseDeferredOrdersPage,
});
